const APP_SCHEME = 'aviajournal';
const APP_PACKAGE = 'ru.aviajournal.app';

export function isMobileBrowser(): boolean {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
}

export function isAndroidBrowser(): boolean {
  return /Android/i.test(navigator.userAgent || '');
}

export function getAppInviteHref(token: string): string {
  const path = `invite/${encodeURIComponent(token)}`;
  if (isAndroidBrowser()) {
    const fallback = encodeURIComponent(window.location.href);
    return (
      `intent://${path}#Intent;scheme=${APP_SCHEME};` +
      `package=${APP_PACKAGE};S.browser_fallback_url=${fallback};end`
    );
  }
  return `${APP_SCHEME}://${path}`;
}
